import auth from "../../middlewares/auth";
export const settingsFolderGradeRoute = [
  {
    path: '/settings/folder_grades',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/folder_grade/FolderGradeList'),
    name: 'settings_folder_grade',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/settings/folder_grades/add',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/folder_grade/FolderGradeForm'),
    name: 'settings_folder_grade_add',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/settings/folder_grades/edit/:id',
    component: () => import(/* webpackChunkName: "settings" */ '../../views/settings/folder_grade/FolderGradeForm'),
    name: 'settings_folder_grade_edit',
    meta: {
      middleware: [
        auth
      ]
    }
  }
];